import { Badge } from '../../../../components/ui';
import { useT } from '../../../../i18n';
import { KHONG_CO, ngayGioVN } from '../../../../lib/dinh-dang';
import { DA_XAC_MINH, NHAN_ROLE, TRANG_THAI_USER_OC } from '../../constants';
import { thoiGianTruoc } from '../../nghiep-vu/danh-ba';
import type { RoleCuaUser, RoleOpenCore, UserOpenCore } from '../../types';

export function BadgeTrangThaiUser({ user }: { user: Pick<UserOpenCore, 'disabled' | 'online'> }) {
  const { t } = useT();
  const v = TRANG_THAI_USER_OC[user.disabled ? 'disabled' : user.online ? 'online' : 'offline'];
  return (
    <Badge variant={v.variant} className="whitespace-nowrap">
      {t(v.khoa)}
    </Badge>
  );
}

export function BadgeCoChua({ co }: { co: boolean }) {
  const { t } = useT();
  const v = DA_XAC_MINH[co ? 'co' : 'chua'];
  return <Badge variant={v.variant}>{t(v.khoa)}</Badge>;
}

/** Mốc hoạt động: dưới một giờ hiện "x giây/phút trước", quá thì hiện ngày giờ đầy đủ. */
export function ThoiGianTruoc({ iso }: { iso: string | null }) {
  const { t, locale } = useT();
  const tg = thoiGianTruoc(iso);
  if (!tg) return <span className="whitespace-nowrap text-xs tabular-nums">{ngayGioVN(iso, locale)}</span>;
  return (
    <span className="whitespace-nowrap text-xs tabular-nums" title={ngayGioVN(iso, locale)}>
      {'giay' in tg ? t('rpaDanhBa.giayTruoc', { so: tg.giay }) : t('rpaDanhBa.phutTruoc', { so: tg.phut })}
    </span>
  );
}

/** Danh sách role gắn trên User; nhiều quá thì gom `+n`. */
export function TheRole({ roles, toiDa = 3 }: { roles: readonly RoleCuaUser[]; toiDa?: number }) {
  const { t } = useT();
  if (!roles.length) return <span className="text-xs text-content-muted">{t('rpaDanhBa.chuaCoRole')}</span>;
  const thua = roles.length - toiDa;
  return (
    <div className="flex max-w-[16rem] flex-wrap gap-1" title={roles.map((r) => r.name || r.id).join(', ')}>
      {roles.slice(0, toiDa).map((r) => (
        <Badge key={r.id || r.name} variant="neutral" className="max-w-[10rem] truncate">
          {r.name || r.id || KHONG_CO}
        </Badge>
      ))}
      {thua > 0 && <Badge variant="neutral">{t('rpaDanhBa.themRole', { so: thua })}</Badge>}
    </div>
  );
}

/** Tên role kèm nhãn hệ thống / License RPA / RPA. */
export function TenRole({ role }: { role: RoleOpenCore }) {
  const { t } = useT();
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-1.5">
      <b className="break-all text-content-primary">{role.name}</b>
      {role.system && <Badge variant={NHAN_ROLE.system.variant}>{t(NHAN_ROLE.system.khoa)}</Badge>}
      {role.managedBy === 'license' && <Badge variant={NHAN_ROLE.license.variant}>{t(NHAN_ROLE.license.khoa)}</Badge>}
      {role.rpaRole && <Badge variant={NHAN_ROLE.rpa.variant}>{t(NHAN_ROLE.rpa.khoa)}</Badge>}
    </div>
  );
}
